import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import styled from "styled-components";
import { MODAL_STYLES } from "../../constants";

const ModalHeader = styled.div`
  background: #ce0e2d;
  color: white;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  font-size: 1em;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.4em;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.15s;

  &:hover {
    opacity: 1;
  }
`;

const ModalBody = styled.div`
  padding: 20px 20px 24px;
`;

const BodyText = styled.p`
  margin: 0;
  line-height: 1.6;
  font-size: 0.95em;
  color: #333;
  text-align: center;
`;

const ButtonRow = styled.div`
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
  gap: 24px;
`;

const ConfirmBtn = styled.button`
  background: #ce0e2d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 7px 18px;
  font-size: 0.85em;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #a30b24;
  }
`;

const VehicleDivisionFailureModal = React.memo(
  ({ isOpen, onDismiss, failedDivisionName }) => {
    const divisionLabel = failedDivisionName
      ? `the ${failedDivisionName} division`
      : "the selected vehicle division";
    return (
      <ReactModal
        isOpen={isOpen}
        style={MODAL_STYLES}
        onRequestClose={onDismiss}
        appElement={document.getElementById("root")}
      >
        <ModalHeader>
          Vehicle Division Unavailable
          <CloseButton onClick={onDismiss}>&times;</CloseButton>
        </ModalHeader>
        <ModalBody>
          <BodyText>
            Failed to return vehicles for {divisionLabel}. The Vehicle Division
            selection has been reverted to the last working division.
          </BodyText>
        </ModalBody>
        <ButtonRow>
          <ConfirmBtn onClick={onDismiss}>OK</ConfirmBtn>
        </ButtonRow>
      </ReactModal>
    );
  }
);

VehicleDivisionFailureModal.displayName = "VehicleDivisionFailureModal";

VehicleDivisionFailureModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  failedDivisionName: PropTypes.string,
};

export default VehicleDivisionFailureModal;
